import { FC, useContext } from "react";

import Button from "~/components/Button/Button";
import OrderContext from "~/contexts/OrderContext";
import DealBuilderContext from "~/contexts/DealBuilderContext";
import TaxContext from "~/contexts/TaxContext";
import ThemeContext from "~/contexts/ThemeContext";
import { groupCartLines } from "~/helpers/bundleDisplay";
import { dealSummary } from "~/helpers/dealHelpers";
import { offerSavingColour } from "~/helpers/offerTheme";

import styles from "./UnlockedDeals.module.css";

// Deals a promo code or reward unlocked that aren't in the cart yet, shown under the code field
const UnlockedDeals: FC = () => {
  const { orderSummary, readonlyCart } = useContext(OrderContext);
  const { deals, openDealBuilder } = useContext(DealBuilderContext);
  const { formatAmount } = useContext(TaxContext);
  const { template } = useContext(ThemeContext);

  const inCart = new Set(
    groupCartLines(orderSummary.lines).flatMap((x) =>
      x.type === "deal" ? [x.deal.promotionCode] : [],
    ),
  );
  const unlocked = deals.filter(
    (deal) =>
      !inCart.has(deal.code) &&
      (orderSummary.unlockedPromotions ?? []).some((x) => x.code === deal.code),
  );

  if (!unlocked.length) {
    return null;
  }

  return (
    <div className={styles.list}>
      {unlocked.map((deal) => (
        <div key={deal.code} className={styles.card}>
          <span
            className={styles.eyebrow}
            style={{ color: offerSavingColour(template) }}
          >
            Unlocked
          </span>
          <b className={styles.name}>
            {deal.name} · {formatAmount(deal.price)}
          </b>
          <span className={styles.summary}>
            {dealSummary(deal)}
            {deal.maxSaving != null &&
              `. Save up to ${formatAmount(deal.maxSaving)}.`}
          </span>
          <Button
            disabled={readonlyCart}
            onClick={() => openDealBuilder(deal.code)}
          >
            Build {deal.name}
          </Button>
        </div>
      ))}
    </div>
  );
};

export default UnlockedDeals;
